import { Resource } from "../resource";

export class TaskComponent extends Resource {
    name:  string | any
    description:  string | any
    created:  Date | any
}